import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "style-parameters" }
const _hoisted_2 = { class: "parameter-count" }
const _hoisted_3 = { class: "parameter-body" }
const _hoisted_4 = { class: "parameter-fields" }
const _hoisted_5 = ["onUpdate:modelValue", "disabled", "aria-label"]
const _hoisted_6 = ["value"]
const _hoisted_7 = ["value"]
const _hoisted_8 = { class: "parameter-actions" }
const _hoisted_9 = ["disabled", "aria-label", "onClick"]
const _hoisted_10 = ["disabled", "aria-label", "onClick"]
const _hoisted_11 = ["disabled", "aria-label", "onClick"]
const _hoisted_12 = {
  key: 0,
  class: "empty-parameters"
}
const _hoisted_13 = ["disabled"]

import { computed, nextTick, ref } from "vue";
import StudioSelectField from "../StudioSelectField.vue";
import TypedValueInput from "../TypedValueInput.vue";
import { compatibleReference, type PresetReference } from "./presetReferences";
import { createStyleParameter, type StyleParameter } from "./stylePresets";


export default /*@__PURE__*/_defineComponent({
  __name: 'StyleParameterSettings',
  props: {
    modelValue: {},
    referenceSources: {},
    label: {},
    disabled: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;
const parameters = computed(() => props.modelValue ?? []);
const integerSources = computed(() => props.referenceSources.filter(source => compatibleReference(source, "Int32")));
const rows = ref<HTMLElement>();

async function addParameter() {
  if (props.disabled || parameters.value.length >= 100) return;
  emit("update:modelValue", [...parameters.value, createStyleParameter()]);
  await nextTick();
  rows.value?.querySelector<HTMLInputElement>(".parameter-row:last-child .parameter-name")?.focus();
}
function removeParameter(index: number) {
  if (props.disabled) return;
  emit("update:modelValue", parameters.value.filter((_, position) => position !== index));
}
function moveParameter(index: number, direction: -1 | 1) {
  const destination = index + direction;
  if (props.disabled || destination < 0 || destination >= parameters.value.length) return;
  const reordered = [...parameters.value];
  reordered.splice(destination, 0, reordered.splice(index, 1)[0]);
  emit("update:modelValue", reordered);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("details", _hoisted_1, [
    _createElementVNode("summary", null, [
      _cache[0] || (_cache[0] = _createElementVNode("span", {
        class: "parameter-arrow",
        "aria-hidden": "true"
      }, "▸", -1)),
      _cache[1] || (_cache[1] = _createElementVNode("span", null, "参数设置", -1)),
      _createElementVNode("span", _hoisted_2, _toDisplayString(parameters.value.length) + " / 100", 1)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _cache[7] || (_cache[7] = _createElementVNode("p", { class: "parameter-description" }, "按列表顺序传入整数，最多 100 项；未设置参数时保持空列表。", -1)),
      _createElementVNode("div", {
        ref_key: "rows",
        ref: rows,
        class: "parameter-list"
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(parameters.value, (param, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: param.id,
            class: "parameter-row"
          }, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("label", null, [
                _cache[2] || (_cache[2] = _createTextVNode("参数名称", -1)),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": ($event: any) => ((param.name) = $event),
                  class: "parameter-name",
                  disabled: __props.disabled,
                  "aria-label": `${__props.label} 参数 ${index + 1} 名称`,
                  placeholder: "例如：角色编号"
                }, null, 8, _hoisted_5), [
                  [_vModelText, param.name]
                ])
              ]),
              _cache[6] || (_cache[6] = _createElementVNode("div", { class: "parameter-type" }, [
                _createElementVNode("span", null, "类型"),
                _createElementVNode("p", null, "整数（Int32）")
              ], -1)),
              _createElementVNode("label", null, [
                _cache[4] || (_cache[4] = _createTextVNode("值来源", -1)),
                _createVNode(StudioSelectField, {
                  modelValue: param.reference,
                  "onUpdate:modelValue": ($event: any) => ((param.reference) = $event),
                  disabled: __props.disabled,
                  "aria-label": `${__props.label} 参数 ${index + 1} 值来源`
                }, {
                  default: _withCtx(() => [
                    _cache[3] || (_cache[3] = _createElementVNode("option", { value: undefined }, "手动填写", -1)),
                    (param.reference && !integerSources.value.some(source => source.value === param.reference))
                      ? (_openBlock(), _createElementBlock("option", {
                          key: 0,
                          value: param.reference
                        }, "引用已失效（可重新选择）", 8, _hoisted_6))
                      : _createCommentVNode("", true),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(integerSources.value, (source) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: source.value,
                        value: source.value
                      }, _toDisplayString(source.label), 9, _hoisted_7))
                    }), 128))
                  ]),
                  _: 2
                }, 1032, ["modelValue", "onUpdate:modelValue", "disabled", "aria-label"])
              ]),
              _createElementVNode("label", null, [
                _cache[5] || (_cache[5] = _createTextVNode("默认值", -1)),
                _createVNode(TypedValueInput, {
                  modelValue: param.defaultValue,
                  "onUpdate:modelValue": ($event: any) => ((param.defaultValue) = $event),
                  "value-type": "Int32",
                  disabled: __props.disabled,
                  "aria-label": `${__props.label} 参数 ${index + 1} 默认值`,
                  placeholder: "默认值（可选）"
                }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled", "aria-label"])
              ])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("button", {
                type: "button",
                class: "parameter-move",
                disabled: __props.disabled || index === 0,
                "aria-label": `${__props.label} 上移参数 ${index + 1}`,
                title: "上移参数",
                onClick: ($event: any) => (moveParameter(index, -1))
              }, "↑", 8, _hoisted_9),
              _createElementVNode("button", {
                type: "button",
                class: "parameter-move",
                disabled: __props.disabled || index === parameters.value.length - 1,
                "aria-label": `${__props.label} 下移参数 ${index + 1}`,
                title: "下移参数",
                onClick: ($event: any) => (moveParameter(index, 1))
              }, "↓", 8, _hoisted_10),
              _createElementVNode("button", {
                type: "button",
                class: "parameter-delete",
                disabled: __props.disabled,
                "aria-label": `${__props.label} 删除参数 ${index + 1}`,
                onClick: ($event: any) => (removeParameter(index))
              }, "删除参数", 8, _hoisted_11)
            ])
          ]))
        }), 128))
      ], 512),
      (!parameters.value.length)
        ? (_openBlock(), _createElementBlock("p", _hoisted_12, "暂无参数。添加后，可在文本或选项编辑中按参数名称填写入参。"))
        : _createCommentVNode("", true),
      _createElementVNode("button", {
        type: "button",
        class: "parameter-add",
        disabled: __props.disabled || parameters.value.length >= 100,
        onClick: addParameter
      }, "＋ 添加参数", 8, _hoisted_13)
    ])
  ]))
}
}

})